import React, { FC } from 'react';
import FieldContainer from '@common/FieldContainer';
import CertRemoveButton from '@components/mypage/premium/CertRemoveButton';
import { AllianceInfoVO } from '@domain/vo/alliance/AllianceInfoVO';

import classnames from 'classnames/bind';
import styles from '../premium.module.scss';

const cx = classnames.bind(styles);

interface CompletedFormProps {
  data: AllianceInfoVO;
  refetchData: () => void;
}

const CompletedForm: FC<CompletedFormProps> = ({ data, refetchData }) => {
  const verifiedDate = data.organizationInfo?.verifiedDate || '';
  const organizationName = data.organizationInfo?.organizationName || '';

  return (
    <div className={cx('contentsWrap')}>
      <FieldContainer name="인증 방법">
        <div className={cx('inputArea')}>
          <input type="text" className={cx('input')} placeholder={`인증 코드 인증 (${verifiedDate})`} disabled={true} />
        </div>
      </FieldContainer>
      <FieldContainer name="인증 기관">
        <div className={cx('inputArea')}>
          <input type="text" className={cx('input')} placeholder={organizationName} disabled={true} />
        </div>
      </FieldContainer>
      <div className={cx('btnWrap')}>
        <CertRemoveButton onClick={refetchData} partnershipType={'ORGANIZATION'} />
      </div>
    </div>
  );
};

export default CompletedForm;
